import clsx from 'clsx';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { FunctionComponent, PropsWithChildren } from 'react';
import styles from './HeaderTableColumn.module.scss';
import HeaderTableSorter from './HeaderTableSorter';
import { Sorter, SortOrder } from '@spike/appointments-list-model';

interface HeaderTableColumnProps extends PropsWithChildren {
    columnSorter?: Sorter;
    selectedSorter?: Sorter | null;
    className?: string;
    onSort?: (sorter: Sorter) => void;
}

export const HeaderTableColumn: FunctionComponent<HeaderTableColumnProps> = props => {
    const clickHandler = () => {
        if (props.columnSorter !== undefined) {
            if (props.columnSorter.id === props.selectedSorter?.id) {
                props.onSort?.({
                    ...props.columnSorter,
                    order:
                        props.selectedSorter.order === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING
                });
            } else {
                props.onSort?.({ ...props.columnSorter });
            }
        }
    };

    return (
        <TableHeaderCell className={props.className}>
            <div
                className={clsx(styles.container, { [styles.sortable]: props.columnSorter !== undefined })}
                onClick={clickHandler}
            >
                {props.children}
                {props.columnSorter && props.columnSorter.id === props.selectedSorter?.id ? (
                    <HeaderTableSorter order={props.selectedSorter?.order} />
                ) : null}
            </div>
        </TableHeaderCell>
    );
};

export default HeaderTableColumn;
